import React, { Component } from 'react'
import PropTypes from 'prop-types'

import CampaignQuotesWrapper from 'agency/digital_renderer/components/CampaignQuotesWrapper'

import Quote from './Quote'
import styles from './styles.scss'

class CampaignQuote extends Component {
  _renderQuoteToggle = (params) => {
    const { campaignQuotes, selectedQuoteId, selectQuoteId } = params
    if (!campaignQuotes.length) return null

    return (
      <ul className={styles.quoteToggle}>
        {campaignQuotes.map(quote => (
          <li key={quote.id}>
            <a
              className={quote.id === selectedQuoteId ? styles.selected : null}
              tabIndex="0"
              onClick={() => selectQuoteId(quote.id)}
            >
              {quote.title}
            </a>
          </li>
        ))}
      </ul>
    )
  }

  _renderQuote = (params) => {
    const { brand } = this.props
    const { campaignQuote } = params

    return <Quote brand={brand} campaignQuote={campaignQuote} />
  }

  _renderContent = params => (
    <div className={styles.root}>
      {this._renderQuoteToggle(params)}
      {this._renderQuote(params)}
    </div>
  )

  render(){
    const { campaignProposal } = this.props

    return <CampaignQuotesWrapper dataSource={campaignProposal} render={params => this._renderContent(params)} />
  }
}

CampaignQuote.propTypes = {
  brand: PropTypes.object.isRequired,
  campaignProposal: PropTypes.object.isRequired,
}

export default CampaignQuote
